import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  ReportDesignItemCustomerSignature,
  ReportDesignItemCustomerSignatureConfig
} from "src/app/modules/bootstrap/modules/report/report-design-item";

@Component({
  selector: "snt-report-designer-customer-signature",
  templateUrl: "report-designer-customer-signature.component.html",
  styles: `
    :host {
      display: flex;
      flex: 1;
    }
  `,
  standalone: false
})
export class ReportDesignerCustomerSignatureComponent implements OnInit {
  @Input()
  item!: ReportDesignItemCustomerSignature;

  @Input()
  readonly: boolean = false;

  @Output()
  config: EventEmitter<ReportDesignItemCustomerSignatureConfig> =
    new EventEmitter();

  formData: { align: string | undefined } = {
    align: undefined
  };

  ngOnInit(): void {
    this.formData.align = this.item.config?.align || "left";
  }

  onFieldDataChanged(): void {
    this.config.emit({
      ...this.item.config,
      ...this.formData
    });
  }
}
